import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <section className="bg-navy text-white py-16 px-6 md:py-24" data-id="element-86">
      <div className="max-w-6xl mx-auto" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-88">
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl mb-6 leading-tight" data-id="element-89">
            CÓMO BLINDAR TU FUTURO TRAS UN DESPIDO O RENUNCIA{' '}
            <span className="text-gold" data-id="element-90">(SIN PÁNICO NI ERRORES LEGALES)</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8" data-id="element-91">
            El Protocolo de Salida Limpia para asegurar tu liquidación, proteger
            tus ahorros y re-ubicarse en 30 días o menos.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col md:flex-row items-center justify-center gap-12" data-id="element-92">
          <div className="w-full md:w-1/2 max-w-md" data-id="element-93">
            <img src="https://cdn.magicpatterns.com/uploads/vD3pUbQu5tBxRfAjQMSnBh/ggfgfgfgfd.png" alt="Kit de Supervivencia ante un Despido o Renuncia" className="w-full h-auto shadow-2xl rounded-lg" data-id="element-94" />
          </div>

          <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-95">
            <CTAButton className="w-full md:w-auto mb-4" data-id="element-96">
              ¡QUIERO EL KIT Y PROTEGER MI FUTURO AHORA!
            </CTAButton>
            <div className="flex items-center justify-center md:justify-start gap-4 text-sm text-gray-400" data-id="element-97">
              <div className="flex items-center gap-1" data-id="element-98">
                <ShieldCheckIcon className="w-4 h-4 text-gold" data-id="element-99" />
                <span data-id="element-100">Acceso inmediato</span>
              </div>
              <span data-id="element-101">·</span>
              <div className="flex items-center gap-1" data-id="element-102">
                <ShieldCheckIcon className="w-4 h-4 text-gold" data-id="element-103" />
                <span data-id="element-104">Pago 100% seguro</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}